import React, { Component } from 'react';
import L from 'leaflet';
import { Map, TileLayer, LayersControl, Marker, AttributionControl } from 'react-leaflet';
import RefreshOutlinedIcon from '@material-ui/icons/RefreshOutlined';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import PauseIcon from '@material-ui/icons/Pause';
/*import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import {FormLabel, Divider} from '@material-ui/core';
import { translateDate } from '../../functions/translateDate';*/
import moment from 'moment';
import 'moment/locale/de';

import cssModule from './mapTempComponent.module.css';

const { BaseLayer } = LayersControl;

let DefaultIcon = L.icon({
    iconUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAApCAYAAADAk4LOAAADW0lEQVRYR+2WSWgUQRSG/9cTPOhJ0EP0omgyPQouOD1JVFBQNLihguIKKqKI6Y5e4jHxqJdo90QUET24gCsoCCpu4JbpxKCgqRHR4CEqBs+iM/2kJ5NxtprqGBEP9mEYuv7/ff1eVb0qwl946C8w8B8yrCr/G+UK1x2boaV/zGRos0GoB9BAxI+Y6RETnleFtJ5XT/e+rZSaNJNw1FlFhBYA85S1IbocIq/1Vaf1upy2LCQSs08x0w5l8CIBMw4nu8wDxb4SiG7EvwA8briAPP0n4ZrV+f4CiG44FwBsGAEga+UO4VpNQ3FykEgsvoaZr44cMBiBNG7o7bSeZf77P1Pn2FOqNHoJYPSfggC4J1xzUQ6iG46fwRo1gPoA7gNQA2CiUs9oE13mQcK6iyG97/MXAGMrmZiwPpkwLw1pItH4PiZuV3huJhPmctJj8QYwP6m4mbxRE3q7d38s1kTmnKhm7Xu/3MsDwrXGU9hwmgk4IhVmU5aN61GnFYQ22bhHPIt0I34W4M1SiOZFRWdztxxibwTR+QrZ7CLdcK4AWCsThaq0mkq9qTbmrNYY16QQgkXhqHMo26PK6wiWSJiOLEg46rQQ4ZC0XIxlFInFdzLzyYrLMZSaLJ7t95duwaPXt09Cuup9Ja9fCdKjzkIQ7qvWPDPmJ7vMx0M6PRZfAeYbKp9wTcrseN1wkgBqVQYAHwC8y2onqPQEXOp1zfUZiKquqmCycQa2Jl3zbAZSU98RCaW9sgfO7wJ8H6cwMdlj9ue6sG7Y1wFaOZKghV6+IVxrlf/uF6SuYwk879Yfg2jaUtG593YBZHABKHZ/4C+gc8Jt2jIkLzwZAzTLQByiuSLR9LQsZDAb+yhAVqBgZUVsC9dqzh8quUhMnW2PD4XoIREiwwUxozed5gVveyz/fMo9Za9EeszZBMa54UJA2CwSZklHll7udMM+DdC24CA+I1xrezm9FJI99e4AmB4A9DyV4sbiMkknPj9gwCb4DeBG4VoPZR+jvNWrjlcm7EkmzOOVslVCspv0OsClLYfhiC5TudwDQabX2dPSHvnzk2vvDL5bPeZr44MHbSnVnAWCZLKJ5l8YeMAjLH6TsF6oACW9S2UIG3GLwEdl++G3J77Y6C8E/+qp+qD88Z+frixbkg5fQgAAAABJRU5ErkJggg==',
    iconSize: [25, 42],
    iconAnchor: [12, 42]
});

L.Marker.prototype.options.icon = DefaultIcon;

class mapComponent extends Component {

    componentWillUnmount() {
        this.stopSlide(this.state.slider_value);
    }

    home_url;
    radar_layers;
    radar_folders;
    slider_min;
    stop_sliding;
    map_object;
    next_layer;
    last_layer;
    user_time;
    legend_type;

    constructor(props) {
        super(props);
        this.state = {
            lat: 54.048433,
            lng: 9.230591,
            zoom: 6,
            slider_value: 0,
            current_layer: { datetime: '', id: 0 },
            slider_max: 100,
            kartentyp: 'Radar',
            paused: false,
            stopped: false,
            mapChanged: false,
            pausedSliderValue: 0,
            sliderMoved: false,
            unit: "metric",
            language: "de",
            legent: {
                "a":{"metric":"-40 °C", "imperial": "-40 °F"},
                "b":{"metric":"-30 °C", "imperial": "-22 °F"},
                "c":{"metric":"-20 °C", "imperial": "-4 °F"},
                "d":{"metric":"-10 °C", "imperial": "14 °F"},
                "e":{"metric":"0 °C", "imperial": "32 °F"},
                "f":{"metric":"5 °C", "imperial": "41 °F"},
                "g":{"metric":"10 °C", "imperial": "50 °F"},
                "h":{"metric":"15 °C", "imperial": "59 °F"},
                "i":{"metric":"20 °C", "imperial": "68 °F"},
                "j":{"metric":"30 °C", "imperial": "86 °F"},
                "k":{"metric":"40 °C", "imperial": "104 °F"},
                "l":{"metric":"50 °C", "imperial": "122 °F"}
            }
        }
        this.mapRef = React.createRef();
        this.home_url = "https://radar.qmet.de/";
        this.radar_layers = [];
        this.radar_folders = [];
        this.slider_min = 0;
        this.stop_sliding = false;
        this.map_object = null;
        this.next_layer = { datetime: '', id: 0 };
        this.last_layer = null;
        this.user_time = '';
        this.mapChanged = false;
        this.selectedFolder = '';
        this.selectedSub = '';
        this.refStopped = false;
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        try{
        return {
            lat: nextProps.propsLon,
            lng: nextProps.propsLat,
            zoom: nextProps.propsZoom,
            kartentyp: nextProps.kartentyp,
            mapChanged: nextProps.mapChanged,
        };
    }catch(error){}
    }

    async shouldComponentUpdate(nextProps) {
        try{
        if (this.state.lat !== nextProps.propsLon || this.state.lng !== nextProps.propsLat || this.state.kartentyp !== nextProps.kartentyp) {
            this.setState({ kartentyp: nextProps.kartentyp }, () => { });
            this.mapChanged = this.state.mapChanged;
            await this.Sleep(1001);
            this.mapChanged = !this.state.mapChanged;
            await this.getRadarFolder();
            this.CreateMapObject();
            await this.getRadarLayers();
            await this.setRadarLayers();
        }
        return true;
    }catch(error){}
    }

    async componentDidMount() {
        try{
        this.setState({unit: this.props.unit.toString(), language: this.props.language.toString()});
        await this.getRadarFolder();
        this.CreateMapObject();
        await this.getRadarLayers();
        await this.setRadarLayers();
        this.user_time = moment((moment().format('YYMMDDhhmm')), 'YYMMDDhhmm').local().format('LLLL');
    }catch(error){}
    }

    getRadarFolder = async () => {
        this.radar_layers = [];
        this.radar_folders = [];
        try {
            let url_radar = 'https://radar.qmet.de:8080/temp';
            let response = await fetch(url_radar);
            let data = await response.json();
            this.radar_folders = data;
        }
        catch (message) {
            console.log('fetching Radar folder', message);
        }
    }

    CreateMapObject = () => {
        try{
        this.map_object = this.mapRef.current.leafletElement;
        this.map_object.dragging.enable();
    }catch(error){}
        }

    handleUnitChange = (event) => {
        try{
        this.setState({unit: event.target.value});
    }catch(error){}
    }

    setTemperaturLegend = () => {

        /*TODO:
        -40°C - very dark blue - RGB: 000-000-139 HEX: 00008B
        -30°C - dark blue - RGB: 000-000-255 	HEX: 0000FF
        -20°C - medium blue - RGB: 030-144-255 	HEX: 1E90FF
        -10°C - blue - RGB: 000-191-255 	HEX: 00BFFF
        0°C - light blue - RGB: 191-239-255 	HEX: BFEFFF
        5°C - pale green - RGB: 193-255-193 	HEX: C1FFC1
        10°C - light green - RGB: 144-238-144 	HEX: 90EE90
        15°C -yellow-green - RGB: 192-255-062 	HEX: C0FF3E
        20°C - yellow - RGB: 255-255-000 	HEX: FFFF00
        30°C - orange - RGB: 255-185-015 	HEX: FFB90F
        40°C - red - RGB: 255-000-000 	HEX: FF0000
        50°C - dark red - RGB: 139-000-000 	HEX: 8B0000
        */
       try{
        return (
            <div className={cssModule.Info}>
                <div className={cssModule.InfoSection}>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(0, 0, 139)' }}></i><span>{this.state.legent.a[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(0, 0, 255)' }}></i><span>{this.state.legent.b[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(30, 144, 255)' }}></i><span>{this.state.legent.c[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(0, 191, 255)' }}></i><span>{this.state.legent.d[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(191, 239, 255)' }}></i><span>{this.state.legent.e[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(193, 255, 193)' }}></i><span>{this.state.legent.f[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(144, 238, 144)' }}></i><span>{this.state.legent.g[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(192, 255, 062)' }}></i><span>{this.state.legent.h[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(255, 255, 0)' }}></i><span>{this.state.legent.i[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(255, 185, 15)' }}></i><span>{this.state.legent.j[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(255, 0, 0)' }}></i><span>{this.state.legent.k[this.state.unit]}</span></div>
                    <div className={cssModule.Legend} style={{clear:'both'}}><i style={{ 'backgroundColor': 'rgb(139, 0, 0)' }}></i><span>{this.state.legent.l[this.state.unit]}</span></div>
                </div>
                {/*<div className={cssModule.InfoSectionUnit}>
                    <FormControl component="fieldset">
                        <span>Unit</span>
                        <RadioGroup aria-label="unit" name="unit" value={this.state.unit} onChange={this.handleUnitChange}>
                            <FormControlLabel value="metric" control={<Radio size="small" color="primary"/>} label="°C"/>
                            <FormControlLabel value="imperial" control={<Radio size="small"  color="primary"/>} label="°F" />
                        </RadioGroup>
                    </FormControl>
                </div>*/}
            </div>
        )
    }catch(error){}
    }

    getRadarLayers = async () => {
        this.radar_layers = [];
        try {

            for (let radarFolder of this.radar_folders) {
                let new_radar_layer_url = this.home_url + 'cloud1/temp/' + radarFolder.folder + "/{z}/{x}/{y}.png";
                let new_radar_layer = window.L.tileLayer(new_radar_layer_url, { tms: true, maxZoom: 18, maxNativeZoom: 8, minZoom: 2, zIndex: 5 });
                let single_layer_object = {};
                let time_str = radarFolder.datetime;
                single_layer_object['id'] = radarFolder.folder;
                single_layer_object['datetime'] = moment.utc(time_str, "YYMMDDhhmm").local().format('LLLL');
                single_layer_object['datetime_en'] = moment.utc(time_str, "YYMMDDhhmm")._d.toLocaleDateString('en-GB',{weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'});
                single_layer_object['standard_date'] = moment.utc(time_str, "YYMMDDhhmm");
                single_layer_object['layer'] = new_radar_layer;
                this.radar_layers.push(single_layer_object);
            }
        } catch (error) { console.log('202010011256', error); }
    }

    setRadarLayers = async () => {
        this.setState({ paused: false, stopped: false, sliderMoved: false }, () => { });
        this.stop_sliding = false;
        this.setState({ slider_max: parseInt(this.radar_folders.length) - 1 }, () => { });

        if (this.last_layer) {
            this.map_object.removeLayer(this.last_layer);
        }

        for (let index = 0; index < this.radar_layers.length; index++) {
            if (this.mapChanged === true) {
                break;
            }
            if (this.refStopped === true) {
                let x = parseInt(index);
                if (x > -1) {
                    this.map_object.removeLayer(this.radar_layers[x].layer);
                }
                this.refStopped = false;
                break;
            }
            if (this.stop_sliding === false) {
                try {

                    this.setState({ current_layer: this.radar_layers[parseInt(index)] }, () => { });

                } catch (message) { console.log('202010160847', message); }

                if (parseInt(this.state.current_layer.id) <= parseInt(this.state.slider_max)) {
                    try {
                        let x = parseInt(index) + 1;
                        if (this.radar_layers[x]) {
                            this.map_object.removeLayer(this.radar_layers[x].layer);
                            this.radar_layers[x].layer.setOpacity(0);
                            this.radar_layers[x].layer.addTo(this.map_object);
                            await this.setMapLoaded(this.radar_layers[x].layer);
                            //this function check weather the current tile layer is completely loaded.
                            if (this.refStopped === true) {
                                this.refStopped = false;
                                break;
                            }
                        }
                    } catch (message) { console.log('202010011154', message); }
                }
                else {
                    await this.Sleep(500);
                }

                try {
                    this.radar_layers[parseInt(index)].layer.setOpacity(.7);
                    let x = parseInt(index) - 1;
                    if (x > -1) {
                        this.map_object.removeLayer(this.radar_layers[x].layer);
                    }
                    if (index === 0) {
                        this.radar_layers[parseInt(index)].layer.addTo(this.map_object);
                        await this.setMapLoaded(this.radar_layers[parseInt(index)].layer);
                        //this function check weather the current tile layer is completely loaded.
                    }
                    this.setState({ slider_value: this.radar_layers[parseInt(index)].id }, () => { });
                    this.last_layer = this.radar_layers[parseInt(index)].layer;
                    await this.Sleep(1000);
                } catch (error) {
                    console.log('202010160848', error);
                }
                this.enableMapMove();
            }
        }
    }

    setRadarLayersPlay = async (startIndex) => {
        let valStartIndex = parseInt(startIndex) + 1;
        this.setState({ paused: false, stopped: false }, () => { })
        this.stop_sliding = false;
        this.setState({ slider_max: parseInt(this.radar_folders.length) - 1 }, () => { });
        if (this.last_layer) {
            this.map_object.removeLayer(this.last_layer);
        }
        for (let index = valStartIndex; index < this.radar_layers.length; index++) {
            if (this.mapChanged === true) {
                break;
            }
            if (this.stop_sliding === false) {
                try {

                    this.setState({ current_layer: this.radar_layers[parseInt(index)] }, () => { });
                } catch (message) { console.log('202010160849', message); }

                if (parseInt(this.state.current_layer.id) <= parseInt(this.state.slider_max)) {
                    try {
                        let x = parseInt(index) + 1;
                        if (this.radar_layers[x]) {
                            this.map_object.removeLayer(this.radar_layers[x].layer);
                            this.radar_layers[x].layer.setOpacity(0);
                            this.radar_layers[x].layer.addTo(this.map_object);
                            await this.setMapLoaded(this.radar_layers[x].layer);
                            //this function check weather the current tile layer is completely loaded.
                        }
                    } catch (message) { console.log('202010160850', message); }
                }
                else {
                    await this.Sleep(500);
                }
                try {
                    let x = parseInt(index) - 1;
                    if (x > -1) {
                        this.map_object.removeLayer(this.radar_layers[x].layer);
                    }
                    this.radar_layers[parseInt(index)].layer.setOpacity(.7);
                    this.radar_layers[parseInt(index)].layer.addTo(this.map_object);
                    this.setState({ slider_value: this.radar_layers[parseInt(index)].id }, () => { });
                    this.last_layer = this.radar_layers[parseInt(index)].layer;
                    await this.Sleep(1000);
                } catch (error) {
                    console.log('202010160851', error);
                }
                this.enableMapMove();
            }
        }
    }

    setMapLoaded = async (argLayer) => {
        try{
        return new Promise((resolve, reject) => {
            if (this.refStopped === true) {
                resolve(argLayer);
            } else {
                argLayer.on("load", async function () {
                    resolve(argLayer);
                });
            }
        });
        }catch(error){console.log('202103231717',error)}
    }

    Sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /*selectTimestep = async () => {
        console.log('-----selectTimestep-----');
        try {
            this.stop_sliding = true;
            //console.log('slider value -- 1 : ', this.state.slider_value);
            this.setState({ current_layer: this.radar_layers[parseInt(this.state.slider_value)] }, () => {});
            this.radar_layers[parseInt(this.state.slider_value)].layer.setOpacity(.7);
            this.radar_layers[parseInt(this.state.slider_value)].layer.addTo(this.map_object);
            if (parseInt(this.state.slider_value) !== parseInt(this.state.current_layer.id)) {
                this.map_object.removeLayer(this.last_layer);
            }
            this.last_layer = this.radar_layers[parseInt(this.state.slider_value)].layer;
            this.enableMapMove();
            //console.log(this.radar_layers);
            //console.log(this.radar_layers[parseInt(this.state.slider_value)]);
            //console.log('slider max : ', this.state.slider_max);
            //console.log('current layer : ', this.state.current_layer.id);
            //console.log('current layer time : ', this.state.current_layer.datetime);

        } catch (error) {
            console.log('202010060241', error);
        }
    }*/

    selectTimestep = async (varSlideValue) => {
        try {
            this.stop_sliding = true;
            this.setState({ current_layer: this.radar_layers[parseInt(varSlideValue)] }, () => { });
            this.radar_layers[parseInt(varSlideValue)].layer.setOpacity(.7);
            this.radar_layers[parseInt(varSlideValue)].layer.addTo(this.map_object);
            if (parseInt(varSlideValue) !== parseInt(this.state.current_layer.id)) {
                this.map_object.removeLayer(this.last_layer);
            }
            this.last_layer = this.radar_layers[parseInt(varSlideValue)].layer;
            this.enableMapMove();
        } catch (error) {
            console.log('202010060241', error);
        }
    }

    enableMapMove = () => {
        try{
        this.map_object.dragging.enable();
    }catch(error){}
        }

    disableMapmove = () => {
        try{
        this.map_object.dragging.disable();
    }catch(error){}
        }

    sliderValueHandler = async (event) => {
        try{
        if (this.last_layer) {
            this.map_object.removeLayer(this.last_layer);
        }
        this.setState({ slider_value: event.target.value, stopped: true, sliderMoved: true, pausedSliderValue: event.target.value}, () => { });
        await this.selectTimestep(event.target.value);
    }catch(error){}
    };

    sliderMoved = async (event) => {
        try{
        this.setState({ sliderMoved: true, pausedSliderValue: this.state.slider_value }, () => { });
    }catch(error){}
    }

    stopSlide = (argVal) => {
        try{
        if (this.stop_sliding === true) {
            this.selectTimestep(argVal);
        }
        else {
            this.stop_sliding = true;
        }
    }catch(error){}
    }

    pauseSlideAnimation = async () => {
        try{
        this.setState({ paused: true, pausedSliderValue: this.state.slider_value }, () => { });
        this.stop_sliding = true;
        await this.Sleep(500);
    }catch(error){}
    }

    stopSlideAnimation = async () => {
        try {
            this.map_object.removeLayer(this.radar_layers[parseInt(this.state.slider_value)].layer);
            this.map_object.removeLayer(this.radar_layers[parseInt(this.state.slider_value) + 1].layer);
            this.stop_sliding = true;
            this.refStopped = true;
            await this.Sleep(750);
            this.setState({ stopped: true }, () => { });
        } catch (error) { console.log('202010161214', error) }
    }

    playSlideAnimation = async () => {
        try{
        await this.Sleep(500);
        this.setState({ paused: false, sliderMoved: false }, () => { });
        this.stop_sliding = false;
        this.setRadarLayersPlay(this.state.pausedSliderValue);
    }catch(error){}
    }

    refreshSlideAnimation = async () => {
        try{
        this.refStopped = false;
        await this.Sleep(500);
        this.setRadarLayers();
        this.setState({ pausedSliderValue: 0 });
    }catch(error){}
    }

    handleMoveEnd = () => {
        /*localStorage.setItem('coordsData', JSON.stringify({
            commonLat : Number(this.mapRef.current.leafletElement.getBounds().getCenter().lat.toLocaleString('en-US', { minimumFractionDigits: 6 })),
            commonLng:  Number(this.mapRef.current.leafletElement.getBounds().getCenter().lng.toLocaleString('en-US', { minimumFractionDigits: 6 })),
            commonZoom: Number(this.mapRef.current.leafletElement.getZoom())}));*/
            try{
        this.props.updateCoords(
            Number(this.mapRef.current.leafletElement.getBounds().getCenter().lat.toLocaleString('en-US', { minimumFractionDigits: 6 })),
            Number(this.mapRef.current.leafletElement.getBounds().getCenter().lng.toLocaleString('en-US', { minimumFractionDigits: 6 })),
            Number(this.mapRef.current.leafletElement.getZoom())
        );
    }catch(error){}
    }

    handleZoomEnd = () => {
        /*localStorage.setItem('coordsData', JSON.stringify({
            commonLat : Number(this.mapRef.current.leafletElement.getBounds().getCenter().lat.toLocaleString('en-US', { minimumFractionDigits: 6 })),
            commonLng:  Number(this.mapRef.current.leafletElement.getBounds().getCenter().lng.toLocaleString('en-US', { minimumFractionDigits: 6 })),
            commonZoom: Number(this.mapRef.current.leafletElement.getZoom())}));*/
            try{
        this.props.updateCoords(
            Number(this.mapRef.current.leafletElement.getBounds().getCenter().lat.toLocaleString('en-US', { minimumFractionDigits: 6 })),
            Number(this.mapRef.current.leafletElement.getBounds().getCenter().lng.toLocaleString('en-US', { minimumFractionDigits: 6 })),
            Number(this.mapRef.current.leafletElement.getZoom())
        );
    }catch(error){}
    }

    render() {
        //console.log('current layer0', this.state.current_layer.datetime_en, this.state.language);
        this.legend_type = this.setTemperaturLegend();
        const position = [this.state.lng, this.state.lat];
        let userDate = new Date();
        let layerDate = new Date(this.state.current_layer.standard_date);
        const markerPosition = [this.props.userLat, this.props.userLng];

        return (
            <div>
                <div className={cssModule.MapControlModule}>
                    {
                        (parseInt(this.state.current_layer.id) <= parseInt(this.state.slider_max)) ?
                            <div className={cssModule.ControlTextContainer}>
                                <span className={cssModule.ControlText}>{layerDate <= userDate ? (this.state.language === 'en' ? 'Past' : 'Vergangenheit') : null}</span>
                                <span className={cssModule.ControlText}>{layerDate > userDate ? (this.state.language === 'en' ? 'Forecast' : 'Vorhersage') : null}</span>
                                <span className={cssModule.ControlTextTime}>{this.state.language === 'en' ? this.state.current_layer.datetime_en : this.state.current_layer.datetime}</span>
                            </div>
                            : null
                    }
                    <div className={cssModule.ControlButtonContainer}>
                        <div className={cssModule.ButtonIcons}>
                            {
                                ((this.state.paused && !this.state.stopped) || this.state.sliderMoved) ?
                                    <span>
                                        <PlayArrowIcon fontSize='large' onClick={this.playSlideAnimation} color='primary' />
                                    </span> : null
                            }
                            {
                                ((parseInt(this.state.current_layer.id) < parseInt(this.state.slider_max)) && !this.state.paused && !this.state.stopped) ?
                                    <span>
                                        <PauseIcon fontSize='large' onClick={this.pauseSlideAnimation} color='primary' />
                                    </span>
                                    : null
                            }
                            {
                                ((parseInt(this.state.current_layer.id) < parseInt(this.state.slider_max)) && !this.state.stopped) ?
                                    <span>
                                        <StopIcon fontSize='large' onClick={this.stopSlideAnimation} color='primary' />
                                    </span> : null
                            }
                            {
                                ((parseInt(this.state.current_layer.id) === parseInt(this.state.slider_max)) || this.state.stopped) ?
                                    <span>
                                        <RefreshOutlinedIcon fontSize='large' onClick={this.refreshSlideAnimation} color='primary' />
                                    </span>
                                    : null
                            }
                        </div>
                        <div className={cssModule.SliderControl}>
                            <input type='range'
                                id='IdSlider'
                                className={cssModule.SliderSelector}
                                min={0}
                                max={this.state.slider_max}
                                value={this.state.slider_value}
                                onInput={this.sliderMoved}
                                onChange={this.sliderValueHandler}
                                onMouseDown={this.disableMapmove}
                                onMouseMove={this.disableMapmove}
                                onMouseUp={this.enableMapMove}
                                onMouseOut={this.enableMapMove} />
                        </div>
                    </div>
                </div>
                {/*<div className={cssModule.DetailsModule}>
                    <div className={cssModule.SliderModule}>
                        <div className={cssModule.DateModule}>
                            {
                                (parseInt(this.state.current_layer.id) <= parseInt(this.state.slider_max)) ?
                                    <span className={cssModule.MapTime}>
                                        <div className={cssModule.TextBold}>{layerDate <= userDate ? 'Vergangenheit' : null}</div>
                                        <div className={cssModule.TextBold}>{layerDate > userDate ? 'Vorhersage' : null}</div>
                                    </span>
                                    : null
                            }
                            {
                                (parseInt(this.state.current_layer.id) <= parseInt(this.state.slider_max)) ?
                                    <div className={cssModule.TimeDisplay}>{this.state.current_layer.datetime}</div>
                                    : null
                            }
                        </div>

                        <input type='range'
                            id='IdSlider'
                            className={cssModule.SliderSelector}
                            min={0}
                            max={this.state.slider_max}
                            value={this.state.slider_value}
                            onInput={this.sliderMoved}
                            onChange={this.sliderValueHandler}
                            onMouseDown={this.disableMapmove}
                            onMouseMove={this.disableMapmove}
                        />

                    </div>
                    <div className={cssModule.ButtonIcons}>
                        {
                            ((this.state.paused && !this.state.stopped) || this.state.sliderMoved) ?
                                <span>
                                    <PlayArrowIcon fontSize='large' onClick={this.playSlideAnimation} color='primary' colorprimary='#17427F' />
                                </span> : null
                        }
                        {
                            ((parseInt(this.state.current_layer.id) < parseInt(this.state.slider_max)) && !this.state.paused && !this.state.stopped) ?
                                <span>
                                    <PauseIcon fontSize='large' onClick={this.pauseSlideAnimation} color='primary' colorprimary='#17427F' />
                                </span>
                                : null
                        }
                        {
                            ((parseInt(this.state.current_layer.id) < parseInt(this.state.slider_max)) && !this.state.stopped) ?
                                <span>
                                    <StopIcon fontSize='large' onClick={this.stopSlideAnimation} color='primary' colorprimary='#17427F' />
                                </span> : null
                        }

                        {
                            ((parseInt(this.state.current_layer.id) === parseInt(this.state.slider_max)) || this.state.stopped) ?
                                <span>
                                    <RefreshOutlinedIcon fontSize='large' onClick={this.refreshSlideAnimation} color='primary' colorprimary='#17427F' />
                                </span>
                                : null
                        }
                    </div>
                </div>*/}

                {this.legend_type}

                <Map
                    ref={this.mapRef}
                    style={{ height: '100vh' }}
                    center={position}
                    zoom={parseInt(this.state.zoom) < 2 ? 2 : this.state.zoom}
                    zoomControl={false}
                    minZoom={2}
                    maxZoom={10}
                    onmoveend={this.handleMoveEnd}
                    onzoomend={this.handleZoomEnd}
                    attributionControl={false}>
                    <TileLayer
                        url="https://radar.qmet.de/tileLayer/{z}/{x}/{y}.png"
                        zIndex='1'
                        attribution='<a target="_blank" rel="nofollow noopener" href="https://leafletjs.com/">Leaflet</a> | &copy; <a target="_blank" rel="nofollow noopener" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'/>
                        <AttributionControl position="bottomright" prefix={false} />
                    <Marker position={markerPosition} draggable={false}></Marker>
                </Map>
            </div>
        );
    }
}

export default mapComponent;
